import { UserProfileCom } from "components";

const UserProfile = () => {
  return (
    <div>
      <UserProfileCom />
    </div>
  );
};

export default UserProfile;
